/**
 * PopupPositioner
 * Utility class for positioning popups/tooltips within viewport bounds
 */
var PopupPositioner = function(options) {
	this.options = {
		$popup: null,           // jQuery element for the popup/tooltip
		$container: null,       // jQuery element for the container (dot/trigger)
		margin: 10,             // Margin from viewport edges
		debug: false            // Enable console logging
	};

	$.extend(true, this.options, options);
};

/**
 * Calculate and apply optimal positioning for the popup
 * @returns {Object} Positioning result with CSS properties to apply
 */
PopupPositioner.prototype.calculatePosition = function() {
	if (!this.options.$popup || this.options.$popup.length === 0) {
		return null;
	}
	if (!this.options.$container || this.options.$container.length === 0) {
		return null;
	}

	var $popup = this.options.$popup;
	var $container = this.options.$container;
	var margin = this.options.margin;
	var debug = this.options.debug;

	// Get viewport dimensions
	var viewportWidth = $(window).width();
	var viewportHeight = $(window).height();
	var scrollLeft = $(window).scrollLeft();
	var scrollTop = $(window).scrollTop();

	// Get container position
	var containerOffset = $container.offset();
	var containerLeft = containerOffset.left;
	var containerTop = containerOffset.top;
	var containerWidth = $container.outerWidth();
	var containerHeight = $container.outerHeight();
	var containerRight = containerLeft + containerWidth;

	// Temporarily make popup visible to measure it
	var wasVisible = $popup.css('visibility') !== 'hidden';
	if (!wasVisible) {
		$popup.css({
			'visibility': 'visible',
			'opacity': '0'
		});
	}

	// Reset all positioning to default
	$popup.css({
		'left': 'auto',
		'right': 'auto',
		'top': 'auto',
		'bottom': '100%',
		'transform': 'none'
	});

	// Force reflow to get accurate measurements
	$popup[0].offsetHeight;

	// Get popup dimensions
	var popupWidth = $popup.outerWidth();
	var popupHeight = $popup.outerHeight();

	// Calculate space available above and below the container
	var viewportTop = scrollTop;
	var viewportBottom = scrollTop + viewportHeight;
	var spaceAbove = containerTop - viewportTop;
	var spaceBelow = viewportBottom - (containerTop + containerHeight);

	// Determine vertical position (above or below)
	var minSpaceNeeded = popupHeight + margin;
	var showBelow = false;
	if (spaceAbove < minSpaceNeeded && spaceBelow >= minSpaceNeeded) {
		showBelow = true;
	} else if (spaceAbove < minSpaceNeeded && spaceBelow < minSpaceNeeded) {
		showBelow = false; // Prefer above if neither has enough space
	}

	// Set vertical position
	if (showBelow) {
		$popup.css({
			'bottom': 'auto',
			'top': '100%'
		});
		$popup.addClass('is-below');
	} else {
		$popup.css({
			'bottom': '100%',
			'top': 'auto'
		});
		$popup.removeClass('is-below');
	}

	// Force reflow after vertical position change
	$popup[0].offsetHeight;

	// Get popup position after vertical adjustment
	var popupPosition = $popup.position();
	var popupLeft = containerLeft + popupPosition.left;
	var popupRight = popupLeft + popupWidth;

	// Calculate horizontal adjustment needed
	var viewportLeft = scrollLeft + margin;
	var viewportRight = scrollLeft + viewportWidth - margin;
	var transformX = 0;

	if (debug) {
		console.log('PopupPositioner: Starting position adjustment', {
			popupPosition: popupPosition,
			popupLeft: popupLeft,
			popupRight: popupRight,
			popupWidth: popupWidth,
			containerLeft: containerLeft,
			containerRight: containerRight,
			viewportLeft: viewportLeft,
			viewportRight: viewportRight,
			viewportWidth: viewportWidth
		});
	}

	// Check overlap/overflow conditions
	var containerOverlapsLeft = containerLeft < viewportLeft;
	var containerOverlapsRight = containerRight > viewportRight;
	var popupOverflowsLeft = popupLeft < viewportLeft;
	var popupOverflowsRight = popupRight > viewportRight;

	if (debug) {
		console.log('PopupPositioner: Overlap/overflow check', {
			containerOverlapsLeft: containerOverlapsLeft,
			containerOverlapsRight: containerOverlapsRight,
			popupOverflowsLeft: popupOverflowsLeft,
			popupOverflowsRight: popupOverflowsRight
		});
	}

	// If popup is wider than available viewport width, center it
	if (popupWidth > (viewportWidth - 2 * margin)) {
		var centerX = scrollLeft + (viewportWidth / 2);
		var popupCenterX = popupLeft + (popupWidth / 2);
		transformX = centerX - popupCenterX;
		if (debug) {
			console.log('PopupPositioner: Popup wider than viewport - centering', {
				transformX: transformX,
				centerX: centerX,
				popupCenterX: popupCenterX
			});
		}
	} else {
		// Check if container is close to edges
		var containerCloseToLeftEdge = containerLeft < (viewportLeft + popupWidth * 0.5);
		var containerCloseToRightEdge = containerRight > (viewportRight - popupWidth * 0.5);
		
		// If container overlaps left edge OR popup overflows left OR container is close to left edge
		if (containerOverlapsLeft || popupOverflowsLeft || containerCloseToLeftEdge) {
			transformX = popupWidth * 0.5;
			if (debug) {
				console.log('PopupPositioner: Container/popup overlaps/close to left - shifting right by half width', {
					transformX: transformX,
					popupWidth: popupWidth,
					containerOverlapsLeft: containerOverlapsLeft,
					popupOverflowsLeft: popupOverflowsLeft,
					containerCloseToLeftEdge: containerCloseToLeftEdge,
					containerLeft: containerLeft,
					threshold: viewportLeft + popupWidth * 0.5
				});
			}
		}
		// If container overlaps right edge OR popup overflows right OR container is close to right edge
		else if (containerOverlapsRight || popupOverflowsRight || containerCloseToRightEdge) {
			transformX = -popupWidth * 0.5;
			if (debug) {
				console.log('PopupPositioner: Container/popup overlaps/close to right - shifting left by half width', {
					transformX: transformX,
					popupWidth: popupWidth,
					containerOverlapsRight: containerOverlapsRight,
					popupOverflowsRight: popupOverflowsRight,
					containerCloseToRightEdge: containerCloseToRightEdge,
					containerRight: containerRight,
					threshold: viewportRight - popupWidth * 0.5
				});
			}
		}
		// Otherwise, check normal overflow cases (for fine-tuning)
		else {
			// Check if popup overflows left edge
			if (popupLeft < viewportLeft) {
				var overflowLeft = viewportLeft - popupLeft;
				transformX = overflowLeft;
				if (debug) {
					console.log('PopupPositioner: Popup overflows left edge (fine-tune)', {
						transformX: transformX,
						overflowLeft: overflowLeft
					});
				}
			}

			// Check if popup overflows right edge (after left adjustment)
			var adjustedPopupRight = popupRight + transformX;
			if (adjustedPopupRight > viewportRight) {
				var overflowRight = adjustedPopupRight - viewportRight;
				transformX -= overflowRight;
				if (debug) {
					console.log('PopupPositioner: Popup overflows right edge (after left adjustment)', {
						transformX: transformX,
						overflowRight: overflowRight,
						adjustedPopupRight: adjustedPopupRight
					});
				}
			}
		}
	}

	// Final safety check: ensure popup never goes off left edge
	var finalPopupLeft = popupLeft + transformX;
	if (finalPopupLeft < viewportLeft) {
		var oldTransformX = transformX;
		transformX = viewportLeft - popupLeft;
		if (debug) {
			console.log('PopupPositioner: Final safety check - forcing left edge alignment', {
				oldTransformX: oldTransformX,
				transformX: transformX,
				finalPopupLeft: finalPopupLeft,
				viewportLeft: viewportLeft
			});
		}
		var finalPopupRight = popupRight + transformX;
		if (finalPopupRight > viewportRight && debug) {
			console.log('PopupPositioner: Warning - popup will overflow right edge after left alignment', {
				finalPopupRight: finalPopupRight,
				viewportRight: viewportRight
			});
		}
	}

	if (debug) {
		console.log('PopupPositioner: Final transformX value', { transformX: transformX });
	}

	// If we temporarily made it visible, hide it again
	if (!wasVisible) {
		$popup.css({
			'visibility': 'hidden',
			'opacity': '0'
		});
	}

	// Return positioning result
	return {
		transformX: transformX,
		showBelow: showBelow,
		popupWidth: popupWidth,
		popupHeight: popupHeight
	};
};

/**
 * Apply the calculated position to the popup
 * @param {Object} positionResult - Result from calculatePosition()
 */
PopupPositioner.prototype.applyPosition = function(positionResult) {
	if (!positionResult || !this.options.$popup) {
		return;
	}

	var $popup = this.options.$popup;
	var transformX = positionResult.transformX;

	// Apply horizontal transform if needed
	if (Math.abs(transformX) > 0.1) {
		$popup.css('transform', 'translateX(' + transformX + 'px)');
	} else {
		$popup.css('transform', 'none');
	}
};

export default PopupPositioner;






